import { render, staticRenderFns } from "./Batches.vue?vue&type=template&id=656a9180&scoped=true"
import script from "./Batches.vue?vue&type=script&lang=js"
export * from "./Batches.vue?vue&type=script&lang=js"
import style0 from "./Batches.vue?vue&type=style&index=0&id=656a9180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656a9180",
  null
  
)

export default component.exports